<script>
import Leaflet from 'leaflet';
import mapCategories from '../models/mapCategories';

export default {
  props: {
    currentMarker: [],
    locale: String,
    location: [],
  },

  data() {
    return {
      container: null,
      map: null,
      marker: [],
      categories: mapCategories,
      selectedSection: '',
      selectedMarker: null,
      inputZipcode: '',
      leafletMarkers: [],
      initialLocation: { lat: 46.7985624, long: 8.2319736, zoom: 9 },
    };
  },

  mounted() {
    this.marker = this.currentMarker;
    this.container = document.querySelector('.js-vue-map');
  },

  created() {
    // ...
  },

  watch: {
    marker: function (val) {
      this.$nextTick(function () {
        this.loadMap();
      });
    },

    selectedSection: function (val) {
      if (val) {
        this.updateLocation(
          this.sections[val].coords.lat,
          this.sections[val].coords.long,
          this.sections[val].name
        );
        this.fadeMarkersNotInSection(this.sections[val].name);
      } else {
        this.resetLocationAndMarkerStyle();
      }
    },

    selectedMarker: function (val) {
      this.updateLocation(val.coords.lat, val.coords.long);
      this.resetMarkerStyle();
    },

    location: function (val) {
      this.updateLocation(val.coords.lat, val.coords.long);
    },
  },

  methods: {
    loadMap() {
      let _this = this;
      this.$nextTick(function () {
        let lat = this.initialLocation.lat;
        let long = this.initialLocation.long;

        if (_this.location !== null) {
          lat = _this.location.coords.lat;
          long = _this.location.coords.long;
        }

        _this.map = Leaflet.map('map').setView(
          [lat, long],
          this.initialLocation.zoom
        );
        Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 15,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(_this.map);

        //  prepare leaflet icons
        let markerList = [];
        for (const category in this.categories) {
          markerList[category] = Leaflet.icon(this.categories[category].icon);
        }

        // set map marker
        _this.marker.forEach((marker, index) => {
          let options = {
            section: marker.section,
            alt: marker.name,
            category: _this.getCategoryByLocale(marker.category, _this.locale),
            name: marker.name,
            street: marker.street,
            zip: marker.zip,
            city: marker.city,
            phone: marker.phone,
            linkout: marker.linkout,
            coords: marker.coords,
          };

          if (marker.category !== '') {
            options.icon = markerList[marker.category];
          }

          const leafletMarkers = Leaflet.marker(
            [marker.coords.lat, marker.coords.long],
            options
          )
            .addTo(_this.map)
            .bindPopup(
              `<strong>${marker.category || ''} ${
                marker.name || ''
              }</strong><br>${marker.street}<br>${marker.zip} ${marker.city}`
            )
            .on('click', (e) => {
              _this.selectedMarker = e.sourceTarget.options;
            });
          _this.leafletMarkers.push(leafletMarkers);
        });
      });
    },

    updateLocation(lat, long) {
      if (this.map !== null) {
        this.map.flyTo(new Leaflet.LatLng(lat, long, 11));
      }
    },

    updateLocationByZipcode() {
      const section = this.getSectionByZipCode();
      if (section) {
        console.log(section.name);
        this.selectedSection = section.name;
      } else {
        this.selectedSection = null;
        console.error(`Keine Sektionsdaten für PLZ: ${this.inputZipcode}`);
      }
    },

    getSectionByZipCode(zipCode) {
      const sectionName = Object.keys(this.sections).find((name) =>
        this.sections[name].plz.includes(zipCode ?? this.inputZipcode)
      );

      return this.sections[sectionName] || null;
    },

    resetMarkerStyle() {
      this.leafletMarkers.forEach((leafletMarker) => {
        leafletMarker.getElement().classList.remove('fade');
        leafletMarker.getElement().classList.remove('accentuate');
      });
    },

    resetLocationAndMarkerStyle() {
      if (this.map !== null) {
        this.map.flyTo(
          new Leaflet.LatLng(
            this.initialLocation.lat,
            this.initialLocation.long
          ),
          this.initialLocation.zoom
        );
        //reset opacity to 1 for all markers
        this.resetMarkerStyle();
      }
    },

    getCategoryByLocale(category, locale) {
      if (typeof this.categories[category] === 'undefined') {
        return '';
      } else if (
        typeof this.categories[category].name[locale] === 'undefined'
      ) {
        locale = 'de';
      }

      return this.categories[category].name[locale];
    },

    fadeMarkersNotInSection(sectionName) {
      if (sectionName) {
        this.leafletMarkers.forEach((leafletMarker) => {
          // style Markers NOT in Sektion
          if (leafletMarker.options.section.name !== sectionName) {
            leafletMarker.getElement().classList.add('fade');
            leafletMarker.getElement().classList.remove('accentuate');
          } else {
            // style Marker IN Sektion
            leafletMarker.getElement().classList.remove('fade');
            leafletMarker.getElement().classList.add('accentuate');
          }
        });
      } else {
      }
    },
  },

  computed: {
    sections: function () {
      let obj = {};
      this.marker.forEach((marker) => {
        obj[marker.section.name] = marker.section;
      });

      return obj;
    },

    existingCategories: function () {
      const existingCategories = this.marker.map((marker) => marker.category);
      const uniqueCategories = [...new Set(existingCategories)];

      let preparedCategories = [];
      for (const category in this.categories) {
        if (uniqueCategories.includes(category)) {
          preparedCategories.push(this.categories[category]);
        }
      }

      return preparedCategories;
    },
  },

  components: {},
};
</script>
